import React, { useState, useEffect } from 'react';
import axios from 'axios';
import PillSpinner from '../components/PillSpinner';

const API_URL = 'http://localhost:5000/api';

const Customers = () => {
  const [customers, setCustomers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [form, setForm] = useState({ name: '', phone: '', email: '' });

  useEffect(() => {
    fetchCustomers();
  }, []);

  const fetchCustomers = async () => {
    try {
      const res = await axios.get(`${API_URL}/customers`);
      setCustomers(res.data);
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    await axios.post(`${API_URL}/customers`, form);
    setForm({ name: '', phone: '', email: '' });
    fetchCustomers();
  };

  if (loading) return <PillSpinner />;

  return (
    <div className="card">
      <h2>👥 Customers / Patients</h2>
      <form onSubmit={handleSubmit} className="medicine-form">
        <input type="text" placeholder="Name" value={form.name} onChange={e => setForm({...form, name: e.target.value})} required />
        <input type="text" placeholder="Phone" value={form.phone} onChange={e => setForm({...form, phone: e.target.value})} />
        <input type="email" placeholder="Email" value={form.email} onChange={e => setForm({...form, email: e.target.value})} />
        <button type="submit" className="btn-submit">Add Customer</button>
      </form>
      <table className="inventory-table">
        <thead><tr><th>Name</th><th>Phone</th><th>Email</th></tr></thead>
        <tbody>
          {customers.map(c => (
            <tr key={c._id}><td>{c.name}</td><td>{c.phone}</td><td>{c.email}</td></tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default Customers;